<template>
  <div>
    <transition name="fade">
      <div
        :key="'delivery_time_dark'"
        class="pu_dark"
        v-show="$store.getters.modal.time"
      ></div>
    </transition>
    <transition name="slide">
      <div
        :key="'delivery_time'"
        class="pu_bottom popup_click_hide"
        v-show="$store.getters.modal.time"
      >
        <div class="pu_bottom_scroll">
          <div @click="close" class="pu_b_close"></div>
          <div class="pu_bottom_inner">
            <div class="pu_select" style="display: block">
              <smooth-picker
                :change="dataChange"
                :data="data"
                :style="style"
                class="_time_picker booking-time-picker"
                ref="smoothPicker"
              />
            </div>
            <div class="pu_tovar_nav pu_tovar_nav_one">
              <div class="pu_tovar_nav_btn">
                <a @click="pick()" class="fbb_btn">
                  {{ text("choice_select_modifier") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
  
<script>
import { SmoothPicker } from "vue-smooth-picker";
import "vue-smooth-picker/dist/css/style.css";
import * as moment from "moment";
import { mapGetters } from "vuex";
import { SET_MODAL, SET_TIMES } from "@/store/mutations.type";

export default {
  name: "DeliveryOneDay",
  components: {
    SmoothPicker,
  },
  props: ["curDate"],
  data() {
    return {
      style: { display: "block" },
      backupState: {
        pickedHour: null,
        pickedTime: null,
      },
      data: [
        {
          currentIndex: 0,
          flex: 1,
          list: [],
          className: "item-group align-right",
        },
        {
          currentIndex: 0,
          flex: 1,
          list: [],
          className: "item-group align-left",
        },
      ],

      hourList: [],
      timeList: [],
      pickedHour: null,
      pickedTime: null,
      intervals: [],
    };
  },
  computed: {
    ...mapGetters(["language", "time"]),
  },
  watch: {
    "$store.getters.modal.time": function (v) {
      this.intervals = [];
      this.hourList = [];
      if (!v || !this.curDate) return;

      const currentDate = moment(this.curDate).format().substring(0, 10);
      const today = moment(new Date()).format().substring(0, 10);
      const daysInfo = this.$store.getters.outletSettings.delivery_time.days;

      let todayStart = null;

      if (currentDate === today) {
        todayStart = moment();
        // todayStart = moment().locale(this.language).utcOffset(this.$store.getters.outletSettings.timezone_offset)
        // .add(this.$store.getters.outletSettings.accept_day_shift, 'd')
        if (this.$store.getters.outlet.hasOwnProperty('data')) {
          todayStart.add(this.$store.getters.outlet.data.time_to_process_order, 'm')
        } else {
          todayStart.add(this.$store.getters.outlet.outlet.time_to_process_order, 'm')
        }
      }
      let intervals = daysInfo[currentDate];
      if (!intervals || !intervals.length) return;

      const startEnds = [];

      intervals.map(el => {
        const startEnd = this.getStartEnd(el);
        if (!startEnd) return;

        let time = moment(startEnd.start);
        for (let i = 0; i < 100; i++) {
          const isBeforeNow = todayStart && todayStart.isAfter(time);
          const inOldInterval = startEnds.some(el => time.isBetween(el.start, el.end));
          const isExists = this.intervals.some(el => el.isSame(time));
          if (!inOldInterval && !isBeforeNow && !isExists)
            this.intervals.push(moment(time));

          time.add(15, "m");

          if (time.isAfter(startEnd.end)) break;
        }

        startEnds.push(startEnd);
      });

      this.intervals.forEach(el => {
        let label = this.$store.getters.timeFormat12 ? el.format("hh") : el.format("HH");
        if (!this.hourList.includes(label)) this.hourList.push(label);
      });

      let index = 0;
      if (this.backupState.pickedHour) {
        index = this.hourList.findIndex(el => el === this.backupState.pickedHour);
        if (index === -1) index = 0;
      }
      this.$refs.smoothPicker.setGroupData(
        0,
        Object.assign({}, this.data[0], {
          list: this.hourList,
          currentIndex: index,
        })
      );

      this.pickedHour = this.hourList[index];
      this.backupState.pickedHour = this.hourList[index];
      this.updateMinutesList(this.pickedHour);
    },

    pickedHour: function (pickedHour) {
      this.updateMinutesList(pickedHour);
    },
  },

  mounted() {
    this.setPickerData();

    this.$store.subscribe(mutation => {
      if (mutation.type === SET_MODAL && mutation.payload.modal === "time") {
        if (mutation.payload.status === true) {
          this.style.display = "flex"; // костыль для smooth-picker
        }
      }
      if (mutation.type === SET_TIMES) {
        this.setPickerData();
      }
    });
  },

  methods: {
    getStartEnd(str) {
      let arr = str.split(" - ");
      if (arr.length != 2) 
        return null;

      let start = arr[0];
      start = this.$store.getters.timeFormat12 ? moment(start, "hh:mm A") : moment(start, "HH:mm");
      let end = arr[1];
      end = this.$store.getters.timeFormat12 ? moment(end, "hh:mm A") : moment(end, "HH:mm");

      if (start.isAfter(end)) 
        return null;

      return { start, end };
    },

    setPickerData() {
      this.backupState.pickedHour = this.pickedHour;
      this.backupState.pickedTime = this.pickedTime;
    },

    pick() {
      this.$emit("pickTime", {
        hour: this.pickedHour,
        minute: this.pickedTime,
      });
      this.close();
    },

    close() {
      this.$store.commit(SET_MODAL, { modal: "time", status: false });
    },

    dataChange(group, itemIndex) {
      if (group === 0) {
        this.pickedHour = this.hourList[itemIndex];
      }
      if (group === 1) {
        this.pickedTime = this.timeList[itemIndex];
      }
      this.setPickerData();
    },

    updateMinutesList(pickedHour) {
      this.timeList = [];
      this.intervals.forEach(el => {
        let hour = this.$store.getters.timeFormat12 ? el.format("hh") : el.format("HH");
        if (pickedHour === hour) {
          let m = el.format("mm");
          this.timeList.push(m);
        }
      });

      let index = 0;
      if (this.backupState.pickedTime) {
        index = this.timeList.findIndex(el => el === this.backupState.pickedTime);
        if (index === -1) index = 0;
      }

      this.backupState.pickedTime = this.pickedTime = this.timeList[index];
      this.backupState.pickedHour = pickedHour;

      this.$refs.smoothPicker.setGroupData(
        1,
        Object.assign({}, this.data[1], {
          list: this.timeList,
          currentIndex: index,
        })
      );
    },
  },
};
</script>

<style>
.booking-time-picker .item-group.align-right::after {
  right: 161px;
  top: 70px;
}
</style>
